JKisio(function() {
    Kisio.Callbacks.autocomplete();
});